/**
 * NOBLE CO. — Premium Theme JavaScript
 * ============================================
 */

(function() {
  'use strict';

  /* --- MOBILE BFCACHE FIX FOR PRELOADER --- */
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

  if (isMobile) {
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        // Page restored from bfcache - ensure preloader is hidden
        var preloader = document.querySelector('.noble-preloader');
        if (preloader) {
          preloader.classList.add('noble-preloader--hidden');
        }
        document.body.classList.add('noble-content-loaded');
      }
    });
  }

  /* --- SUBNAV MARQUEE: Clone text to fill screen, seamless scroll --- */
  function initSubnavMarquee() {
    var container = document.getElementById('nav-subnav-container');
    if (!container) return;

    var text = 'Frete grátis para todo o Brasil';
    var containerWidth = container.offsetWidth;

    // Create a temp item to measure single item width
    var temp = document.createElement('div');
    temp.className = 'noble-marquee-item';
    temp.style.position = 'absolute';
    temp.style.visibility = 'hidden';
    temp.textContent = text;
    document.body.appendChild(temp);
    // Account for item padding (60px each side) + dot padding (60px each side)
    var itemWidth = temp.offsetWidth + 120 + 120 + 10;
    document.body.removeChild(temp);

    // Calculate how many copies needed to fill at least 2x the viewport
    var copiesNeeded = Math.ceil((containerWidth * 2) / itemWidth) + 2;

    // Build marquee track: two identical halves for seamless 50% loop
    var track = document.createElement('div');
    track.className = 'noble-marquee-track';

    for (var half = 0; half < 2; half++) {
      for (var i = 0; i < copiesNeeded; i++) {
        var item = document.createElement('div');
        item.className = 'noble-marquee-item';
        item.textContent = text;
        track.appendChild(item);

        var dot = document.createElement('span');
        dot.className = 'noble-marquee-dot';
        dot.textContent = '\u2022';
        track.appendChild(dot);
      }
    }

    // Set animation duration based on total content width
    var totalItems = copiesNeeded * 2;
    var duration = totalItems * 3;
    track.style.animationDuration = duration + 's';

    // Replace container content with marquee
    container.innerHTML = '';
    container.appendChild(track);
  }

  // Run marquee immediately
  initSubnavMarquee();

  /* --- FEATURED COLLECTION GRID: Apply to specific sections + all after birkenstock --- */
  var gridSectionIds = ['16474367296877ff27', 'featured_collection_Pr6EqY'];
  var birkenstockFound = false;

  document.querySelectorAll('[data-section-type="featured-collection"]').forEach(function(section) {
    var id = section.getAttribute('data-section-id');
    if (gridSectionIds.indexOf(id) !== -1) {
      section.classList.add('noble-grid-section');
    }
    if (id === 'featured_collection_Pr6EqY') {
      birkenstockFound = true;
    } else if (birkenstockFound) {
      section.classList.add('noble-grid-section');
    }
  });

  /* --- AMBIENT BACKGROUND GLOWS WITH PARALLAX --- */
  var glowCanvas = document.createElement('div');
  glowCanvas.className = 'noble-glow-canvas';

  var glowConfigs = [
    { size: 1400, x: '-8%',  y: '5%',   opacity: 0.19, speed: -0.25, anim: 'nobleFloat1' },
    { size: 1100, x: '70%',  y: '20%',  opacity: 0.19, speed: -0.45, anim: 'nobleFloat2' },
    { size: 1200, x: '30%',  y: '50%',  opacity: 0.19, speed: -0.30, anim: 'nobleFloat3' },
    { size: 1000, x: '85%',  y: '65%',  opacity: 0.19, speed: -0.55, anim: 'nobleFloat4' },
    { size: 1300, x: '-5%',  y: '80%',  opacity: 0.19, speed: -0.20, anim: 'nobleFloat5' },
  ];

  var glowEls = [];
  for (var i = 0; i < glowConfigs.length; i++) {
    var cfg = glowConfigs[i];
    var glow = document.createElement('div');
    glow.className = 'noble-glow';
    glow.style.cssText = 'width:' + cfg.size + 'px;height:' + cfg.size + 'px;' +
      'left:' + cfg.x + ';top:' + cfg.y + ';' +
      'background:radial-gradient(circle,rgba(0,0,0,' + cfg.opacity + ') 0%,rgba(0,0,0,' + (cfg.opacity * 0.3) + ') 35%,transparent 70%);' +
      'animation:' + cfg.anim + ' ' + (18 + i * 4) + 's ease-in-out infinite;';
    glowCanvas.appendChild(glow);
    glowEls.push({ el: glow, speed: cfg.speed, baseY: parseFloat(cfg.y) });
  }

  document.body.appendChild(glowCanvas);

  // Parallax on scroll — use margin-top to avoid overriding CSS animation transform
  var glowTicking = false;
  window.addEventListener('scroll', function() {
    if (!glowTicking) {
      requestAnimationFrame(function() {
        var scrollY = window.pageYOffset;
        for (var i = 0; i < glowEls.length; i++) {
          var g = glowEls[i];
          g.el.style.marginTop = (scrollY * g.speed) + 'px';
        }
        glowTicking = false;
      });
      glowTicking = true;
    }
  }, { passive: true });

  /* --- SCROLL PROGRESS INDICATOR --- */
  var progressBar = document.createElement('div');
  progressBar.className = 'noble-scroll-progress';
  document.body.appendChild(progressBar);

  var header = document.querySelector('.header');

  /* --- UNIFIED THROTTLED SCROLL HANDLER --- */
  var scrollTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      requestAnimationFrame(function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        if (docHeight > 0) {
          progressBar.style.width = (scrollTop / docHeight) * 100 + '%';
        }
        if (header) {
          if (scrollTop > 100) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }
        }
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  /* --- PRELOADER PAGE TRANSITIONS --- */
  var preloader = document.getElementById('noble-preloader');
  var isPageTransition = sessionStorage.getItem('noble-page-transition');

  if (preloader) {
    // Reveal page: hide preloader and show content
    var revealed = false;
    function revealPage() {
      if (revealed) return;
      revealed = true;
      preloader.classList.add('noble-preloader--out');
      setTimeout(function() {
        preloader.classList.add('noble-preloader--hidden');
        document.body.classList.add('noble-content-loaded');
        sessionStorage.removeItem('noble-page-transition');
      }, 350);
    }

    if (isPageTransition) {
      revealPage();
    } else if (document.readyState === 'complete') {
      setTimeout(revealPage, 300);
    } else {
      window.addEventListener('load', function() {
        setTimeout(revealPage, 300);
      });
      // Safety fallback: reveal after 4s even if load never fires
      setTimeout(revealPage, 4000);
    }

    document.body.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;

      var href = link.getAttribute('href');

      if (!href ||
          href.startsWith('#') ||
          href.startsWith('tel:') ||
          href.startsWith('mailto:') ||
          (href.startsWith('http://') && !href.includes(window.location.hostname)) ||
          (href.startsWith('https://') && !href.includes(window.location.hostname)) ||
          href.includes('/admin') ||
          href.includes('.pdf') ||
          href.includes('.zip') ||
          link.hasAttribute('data-no-instant') ||
          link.getAttribute('target') === '_blank' ||
          link.closest('.product-gallery')) {
        return;
      }

      e.preventDefault();

      // Show preloader
      preloader.classList.remove('noble-preloader--out', 'noble-preloader--hidden');
      document.body.classList.remove('noble-content-loaded');

      setTimeout(function() {
        sessionStorage.setItem('noble-page-transition', 'true');
        window.location.href = href;
      }, 350);
    });
  }

  /* --- SCROLL REVEAL ANIMATIONS --- */
  var revealSections = document.querySelectorAll('.section, .slideshow__slide, .promo-block');

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var section = entry.target;
          section.classList.add('is-visible');

          // Stagger children with random delays
          var children = section.querySelectorAll('.product-item, .collection-item, .block-list__item, .section__header, .section__title, .product-list, .featured-collection__header, .featured-collection__content, .heading.h1');
          children.forEach(function(child) {
            var delay;
            if (child.classList.contains('product-item')) {
              delay = 0.4 + (Math.random() * 0.25); // Product items: base 0.4s + random 0-0.25s
            } else {
              delay = 0; // Other elements (titles, etc): instant
            }
            child.style.transitionDelay = delay.toFixed(3) + 's';
            child.classList.add('noble-child-visible');

            // Clear delay after animation completes so hover works instantly
            setTimeout(function() {
              child.style.transitionDelay = '0s';
            }, (delay + 0.4) * 1000);
          });

          revealObserver.unobserve(section);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });

    revealSections.forEach(function(el) {
      el.classList.add('noble-reveal');

      // Prepare children for staggered reveal
      var children = el.querySelectorAll('.product-item, .collection-item, .block-list__item, .section__header, .section__title, .product-list, .featured-collection__header, .featured-collection__content, .heading.h1');
      children.forEach(function(child) {
        child.classList.add('noble-child');
      });

      revealObserver.observe(el);
    });
  }

  /* Header scroll state handled by unified scroll handler above */

  /* --- SMOOTH ANCHOR LINKS --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  /* --- PRODUCT ZOOM DELAY --- */
  function initZoomDelay() {
    var zoomWrapper = document.querySelector('.product__zoom-wrapper');
    var productGallery = document.querySelector('.product-gallery__carousel');
    var galleryImages = document.querySelectorAll('.product-gallery__image');

    if (zoomWrapper || productGallery || galleryImages.length) {
      // Disable zoom initially
      if (zoomWrapper) zoomWrapper.style.pointerEvents = 'none';
      if (productGallery) productGallery.classList.add('zoom-disabled');
      galleryImages.forEach(function(img) {
        img.style.pointerEvents = 'none';
      });

      // Enable after 1.7s
      setTimeout(function() {
        if (zoomWrapper) zoomWrapper.style.pointerEvents = '';
        if (productGallery) productGallery.classList.remove('zoom-disabled');
        galleryImages.forEach(function(img) {
          img.style.pointerEvents = '';
        });
      }, 1700);
    }
  }

  // Run immediately
  initZoomDelay();

  // Also run when DOM is ready (for cached page loads)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomDelay);
  }

  // Also run when preloader finishes
  var zoomObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('noble-content-loaded')) {
        initZoomDelay();
        zoomObserver.disconnect();
      }
    });
  });
  zoomObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* --- PRODUCT PAGE: QUANTITY BUTTON ANIMATION --- */
  var qtyButtons = document.querySelectorAll('.quantity-selector__button');
  qtyButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.style.transform = 'scale(0.9)';
      var self = this;
      setTimeout(function() {
        self.style.transform = 'scale(1)';
      }, 150);
    });
  });

  /* --- PRODUCT PAGE: SWATCH SELECTION ANIMATION --- */
  var swatches = document.querySelectorAll('.block-swatch__item, .color-swatch__item');
  swatches.forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      this.style.transform = 'scale(0.95)';
      var self = this;
      setTimeout(function() {
        self.style.transform = 'scale(1)';
      }, 150);
    });
  });

  /* --- PRODUCT PAGE: INFO REVEAL --- */
  var productInfo = document.querySelector('.product__info');
  if (productInfo) {
    productInfo.style.opacity = '0';
    productInfo.style.transform = 'translateY(30px)';

    setTimeout(function() {
      productInfo.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      productInfo.style.opacity = '1';
      productInfo.style.transform = 'translateY(0)';
    }, 300);
  }
})();


/* ============================================
   EXISTING CODE (Preserved)
   ============================================ */

if (window.matchMedia("(max-width: 768px)").matches) {
  var scrollTopTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTopTicking) {
      requestAnimationFrame(function() {
        var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
            btn = document.getElementById('scrollToTop');
        if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
        scrollTopTicking = false;
      });
      scrollTopTicking = true;
    }
  }, { passive: true });
}

window.onload = function(){
  $('.footer__block-item.footer__block-item--links:nth-child(2) button').click()
}

$(".block-swatch__radio, .variant-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

function increaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById('number').value = value;
}

function decreaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value < 1 ? value = 1 : '';
  value--;
  document.getElementById('number').value = value;
}

$('.options:first-child').addClass('active')

$(".options").each(function(index) {
  $(this).on("click", function(){
    var $this = $(this);
    var $active = $('.options.active');
    var $activeDesconto = $active.find('.selector-desconto');

    $activeDesconto.text($activeDesconto.attr('cup'));
    $active.removeClass('active');
    $this.addClass('active');

    var $newDesconto = $this.find('.selector-desconto');
    $newDesconto.append(' APLICADO');

    var newPrice = $this.find('.valortot b').text();
    var newPrecode = $this.find('.valortot span').text();
    var cupom = $newDesconto.text();

    var $priceList = $('.price-list');
    var $price = $('.price');

    $priceList.find('.precode').remove();
    $priceList.find('.price--compare').remove();
    $priceList.append('<p class="precode">' + newPrecode + '</p>');
    $price.text(newPrice);
    $price.find('.selector-desconto').remove();

    if (cupom !== '')
      $price.append('<p class="selector-desconto">' + cupom + '</p>');

    setTimeout(function(){ parcelamento2() }, 100);
  });
});

$(".options").each(function( index ) {
  var valor = parseFloat($(this).find('.valorunico b').text().replace('R$ ', '').trim())
  var menor = $('.options:first-child .valorunico b').text().replace('R$ ', '').replace(',', '.').trim()
  var result = ((valor - menor)*100 / valor) * (-1);
  var porcenta = 'CUPOM ' + result.toFixed(0).replace('.', ',') + '% OFF'
  $(this).find('.selector-desconto').attr('cup', porcenta )
  $(this).find('.selector-desconto').text(porcenta)
});

$(".product-form").each(function () {
  $(this).on('click', '.botaocmprar', function (event) {
    var arraydeprodutos = [];
    event.stopImmediatePropagation();
    var idproduto = parseInt($('.options.active .iddavariante').attr('val'))
    var qtdproduto = parseInt($('.options.active .iddavariante').attr('qtd'))
    arraydeprodutos.push({
      id: idproduto,
      quantity: qtdproduto
    });
    console.log(arraydeprodutos)

    data = {
      items: arraydeprodutos
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add',
      data: data,
      dataType: 'json',
      success: function (data) {
        setTimeout(function () {
          window.location.href = '/cart'
        }, 500);
      }
    });
  });
})
